var CallBackOptionSuccessView, CommonBaseView, SupportThanksForContactingTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

SupportThanksForContactingTemplate = require('../../../../thanks_for_contacting.html.mustache');

CommonBaseView = require("../../common/views/common_base_view");

CallBackOptionSuccessView = (function(superClass) {
  extend(CallBackOptionSuccessView, superClass);

  function CallBackOptionSuccessView() {
    return CallBackOptionSuccessView.__super__.constructor.apply(this, arguments);
  }

  CallBackOptionSuccessView.prototype.template = SupportThanksForContactingTemplate;

  CallBackOptionSuccessView.prototype.render = function(params) {
    this.$el.empty();
    return this.$el.append(toHtml(this.template, this.toHash(params.waitTime, params.phone_number), this.I18nScope));
  };

  CallBackOptionSuccessView.prototype.toHash = function(waitTime, phone_number) {
    return {
      phoneCallReceivemsg: I18n.translate('js.modules.support.call_me_back_phone_call_receive_msg', {
        display_wait_time: waitTime
      }),
      weContactYouPhoneNumberMsg: I18n.translate('js.modules.support.we_will_call_you', {
        display_phone_number: phone_number
      }),
      isCallMeBackFlow: true,
      showCallBackThankYouMsg: true
    };
  };

  return CallBackOptionSuccessView;

})(CommonBaseView);

module.exports = CallBackOptionSuccessView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9jb21tb24vY2FsbF9tZV9iYWNrX3N1Y2Nlc3Nfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9ybXVydWdhbi9uYXBpc3RyYW5vL2J1aWxkLzE1MDE3ODIwMTYzMDYtNTk0MzUvcHJvZHVjdGlvbi0yMDE3LjA4LjAzXzE3LjM2L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9lbWFpbF9mb3JtL2NvbW1vbi9jYWxsX21lX2JhY2tfc3VjY2Vzc192aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLDZFQUFBO0VBQUE7OztBQUFBLGtDQUFBLEdBQXFDLE9BQUEsQ0FBUSxpREFBUjs7QUFDckMsY0FBQSxHQUFpQixPQUFBLENBQVEscUNBQVI7O0FBRVg7Ozs7Ozs7c0NBQ0osUUFBQSxHQUFVOztzQ0FFVixNQUFBLEdBQVEsU0FBQyxNQUFEO0lBQ04sSUFBQyxDQUFBLEdBQUcsQ0FBQyxLQUFMLENBQUE7V0FDQSxJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxNQUFBLENBQU8sSUFBQyxDQUFBLFFBQVIsRUFBa0IsSUFBQyxDQUFBLE1BQUQsQ0FBUSxNQUFNLENBQUMsUUFBZixFQUF5QixNQUFNLENBQUMsWUFBaEMsQ0FBbEIsRUFBaUUsSUFBQyxDQUFBLFNBQWxFLENBQVo7RUFGTTs7c0NBSVIsTUFBQSxHQUFPLFNBQUMsUUFBRCxFQUFXLFlBQVg7V0FDTDtNQUFBLG1CQUFBLEVBQXFCLElBQUksQ0FBQyxTQUFMLENBQWUsd0RBQWYsRUFBeUU7UUFBQyxpQkFBQSxFQUFtQixRQUFwQjtPQUF6RSxDQUFyQjtNQUNBLDBCQUFBLEVBQTRCLElBQUksQ0FBQyxTQUFMLENBQWUscUNBQWYsRUFBc0Q7UUFBQyxvQkFBQSxFQUFzQixZQUF2QjtPQUF0RCxDQUQ1QjtNQUVBLGdCQUFBLEVBQWtCLElBRmxCO01BR0EsdUJBQUEsRUFBeUIsSUFIekI7O0VBREs7Ozs7R0FQK0I7O0FBYXhDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
